// Centralized role predicates for CRM access.
//
// A "CRM/sales user" is anyone the backend treats like a SalesPerson for CRM
// routes: an actual SalesPerson, or a Consultant who was granted the sales
// person role (hasSalesPersonRole). Use these helpers everywhere instead of
// re-deriving the predicate inline so the two roles stay in lockstep.

const normalizeRole = (role) => (role || "").toString().trim().toLowerCase();

/** True when the user is a Consultant who has been granted the sales role. */
export const isCrmConsultant = (user = {}) =>
  normalizeRole(user.userRole) === "consultant" && Boolean(user.hasSalesPersonRole);

/** True when the user is a dedicated SalesPerson account. */
export const isSalesPerson = (user = {}) =>
  normalizeRole(user.userRole) === "salesperson";

/**
 * True when the user should see the full CRM UI with SalesPerson-equivalent
 * rights: a SalesPerson, or a Consultant with hasSalesPersonRole.
 */
export const isCrmSalesUser = (user = {}) =>
  isSalesPerson(user) || isCrmConsultant(user);

export const isAdminRole = (user = {}) => normalizeRole(user.userRole) === "admin";
